var React = require('react');

function PencilRuler (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M109.5 244L244 109.5l-44-44.1-61.8 61.6a8 8 0 0 1-11.2 0l-11.2-11.2a8 8 0 0 1 0-11.2L177.5 43 143.9 9.3a31.7 31.7 0 0 0-44.9 0L9.3 99a31.7 31.7 0 0 0 0 44.9L109.5 244zm388.4-116.8a48 48 0 0 0 0-67.9l-45.2-45.2a48 48 0 0 0-68 0l-46 46L452 173.3l46-46zM316.1 82.7l-297 297L.3 487A21.2 21.2 0 0 0 25 511.7l107.5-18.9L429.3 196 316 82.7zm186.6 285.4l-33.6-33.6-61.7 61.7a8 8 0 0 1-11.2 0L385 385a8 8 0 0 1 0-11.2l61.7-61.7-44.2-44.2L268 402.5l100.2 100.2a31.7 31.7 0 0 0 44.9 0l89.7-89.7a31.7 31.7 0 0 0 0-44.9z"}));
}

PencilRuler.defaultProps = {"aria-hidden":"true","data-icon":"pencil-ruler","viewBox":"0 0 512 512"};

module.exports = PencilRuler;

PencilRuler.default = PencilRuler;
